import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';

const PANEL_ID = 'poster-editor-item-opacity-panel';

export default function PosterEditorItemOpacityModal(): ReactElement<any> {
  const height = '144px';
  const maxWidth = '800px';

  return (
    <Modal
      modalId={MODALS_IDS.POSTER_EDITOR_ITEM_OPACITY_MODAL}
      panelId={PANEL_ID}
      modalHeight={height}
      mobileHeight={height}
      isBottomSheetOnMobile
      isBottomSheetNonBlocking
      modalMaxWidth={maxWidth}
      modalWidth="100%"
      bottomSheetCloseThreshold={100}
    >
      <LazyPanel
        panelDirectoryName="poster-editor-item-opacity-panel"
        panelProps={{
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openPosterEditorItemOpacityModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_ITEM_OPACITY_MODAL,
      panelProps: {
        panelId: PANEL_ID,
      },
    })
  );
};
